<article [ngClass]="[needSaving ? 'not-saved' : 'saved', saving ? 'saving' : '']">
  <h2
    [ngClass]="['heading-underline', !loadTriggered ? 'clickable' : 'non-clickable']"
    [matTooltip]="!loadTriggered ? 'Click to expand.' : null"
    (click)="!loadTriggered ? expandAndLoad() : null">
    <div *ngIf="loadTriggered" class="back-button" (click)="router.navigate([DataToolsApps.DUPLIKIT_DASHBOARD])">
      <i class="bhi-previous"></i>
      <span>Back to Dashboard</span>
    </div>
    {{DataToolsAppsTitles.DUPLIKIT}} Report Fields
    <i class="bhi-info"
       [matTooltip]="'Choose the additional data points you would like to see whilst reviewing duplicate matches.'"></i>
    <span *ngIf="loadTriggered" class="sub-info"><a
                                                    (click)="router.navigate([DataToolsApps.DUPLIKIT_DASHBOARD])"
                                                    [matTooltip]="'Return to ' + DataToolsAppsTitles.DUPLIKIT" matTooltipShowDelay="500">DupliKit</a></span>
    <span *ngIf="!loadTriggered" class="sub-info">Click to expand.</span>
  </h2>

  <div *ngIf="loadTriggered">
    <span *ngIf="loading.candidate && loading.company && loading.contact; else loadComponent">
      <app-loading></app-loading>
    </span>
    <ng-template #loadComponent>
      <table class="table table-striped table-no-border-bottom no-mar-b">
        <tbody *ngFor="let entity of entities">
        <tr class="entityRow">
          <td class="entityName">
            <i class="bhi-{{ entity === 'contact' ? 'person' : entity }}"></i>
            <h3>{{ entity | titlecase }}</h3>
          </td>
          <td class="fieldSelection2">
              <div class="fieldRow" *ngFor="let field of selectedFields[entity]; let i = index">
                  <mat-select *ngIf="selectedFields[entity][i]" [(ngModel)]="selectedFields[entity][i]" (ngModelChange)="change()">
                      <mat-option *ngFor="let option of BHMetaFields[entity]"
                                  [value]="loading[entity] ? 'loading...' : option.fieldName">
                          {{ loading[entity] ? 'loading...' : option.fieldLabel + ' (' + option.fieldName + ')' }}
                      </mat-option>
                  </mat-select>
                  <i class="bhi-times removeField" *ngIf="selectedFields[entity][i]"
                     (click)="removeSelectedField(entity, i)">
                  </i>
              </div>
              <div class="fieldRow">
                  <span *ngIf="loading[entity]">
                    Loading... <!-- TODO: spinner -->
                  </span>
                  <span class="addField" (click)="addReportField(entity);">
                    <i class="bhi-add"></i>
                    ADD FIELD
                  </span>
              </div>
          </td>
        </tr>
        </tbody>
      </table>
    </ng-template>
  </div>
</article>
